
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import Accordion from '@devsisters/ui-careers/lib/Accordion';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"accordion"}}>{`Accordion`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { Accordion } from '@devsisters/ui/careers';
// 또는 import Accordion from '@devsisters/ui-careers/lib/Accordion';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h1>pc</h1>\n<State\n  initialState={{\n    value: [\n      { title: \'제목1\', contents: \'내용1\', open: false },\n      { title: \'제목2\', contents: \'내용2\', open: false },\n      { title: \'제목3\', contents: \'내용3\', open: false },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <Accordion\n      type=\"pc\"\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>\n<h1>mobile</h1>\n<State\n  initialState={{\n    value: [\n      { title: \'제목1\', contents: \'내용1\', open: false },\n      { title: \'제목2\', contents: \'내용2\', open: false },\n      { title: \'제목3\', contents: \'내용3\', open: false },\n    ],\n  }}\n>\n  {({ state, setState }) => (\n    <Accordion\n      type=\"mobile\"\n      value={state.value}\n      onChange={value => setState({ value })}\n    />\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,Accordion}}>
  <h1>pc</h1>
  <State initialState={{ value: [
    { title: '제목1', contents: '내용1', open: false },
    { title: '제목2', contents: '내용2', open: false },
    { title: '제목3', contents: '내용3', open: false },
  ] }}>
    {({ state, setState }) => (
      <Accordion
        type='pc'
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
  <h1>mobile</h1>
  <State initialState={{ value: [
    { title: '제목1', contents: '내용1', open: false },
    { title: '제목2', contents: '내용2', open: false },
    { title: '제목3', contents: '내용3', open: false },
  ] }}>
    {({ state, setState }) => (
      <Accordion
        type='mobile'
        value={state.value}
        onChange={value => setState({ value })}
      />
    )}
  </State>
</Playground>
           </MDXTag>
  }
}
  